export default "__VITE_ASSET__DHymN_EE__"